import { CircularProgress } from '@backoffice-frontend/patterns'
import { Card } from '@moia-dev/pace-web'

export const LoadingLivestream = () => {
  return (
    <Card
      outline
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.semantic.ColorSurfaceReduced,
        height: '100%',
        minHeight: '300px',
      })}
    >
      <CircularProgress
        css={{
          display: 'block',
          margin: '0 auto',
          height: '100%',
        }}
      />
    </Card>
  )
}
